module.exports = __webpack_public_path__ + "img/2210.15767250.gif";